<template>
  <div class="wrap">
    <!-- banner图 -->
    <div>
      <!-- <van-swipe :autoplay="10000" class="swiper">
        <van-swipe-item v-for="(image, index) in bannerList" :key="index" >
          <img :src="image.ossMaterial" @click="previewImg(images,index)"/>
        </van-swipe-item>
      </van-swipe> -->
      <div class="recent">
        <div class="empty">
          <van-notice-bar left-icon="volume-o" :scrollable="false" background="#F3EAF3">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="3000"
              :show-indicators="false"
            >
              <van-swipe-item v-for="(item,index) in recentList" :key="index">{{ item }}</van-swipe-item>
            </van-swipe>
          </van-notice-bar>
        </div>
      </div>
    </div>
    <div class="buy-vip" @click="toVipCard">
      <img src="../../assets/images/buy-vip.png"/>
    </div>
    <div class="container">
      <div>
        <div v-if="testingMap[5]" @click="toTesting(testingMap[5])" class="child">
          <div class="flex-row-center">
            <img :src="testingMap[5].ossMaterial" />
          </div>
          <div class="title pl40">{{ testingMap[5].name }}</div>
          <div class="flex-row-between info pl40 pr40">
            <div>{{ testingMap[5].haveVip ? '会员免费' : testingMap[5].amount > 0 ? '￥' + testingMap[5].amount + '元' : '免费测试' }}</div>
            <div>{{ testingMap[5].count }}人购买</div>
          </div>
        </div>
        <div @click="toTestingRecord" class="my-report flex-col-center">
          <img src="../../assets/images/to-report.png"/>
          <div class="title">我的报告</div>
        </div>
        <!-- <div @click="toVipCard" class="my-report flex-col-center">
          <img src="../../assets/images/to-report.png"/>
          <div class="title">年卡购买</div>
        </div> -->
      </div>
      <div>
        <div v-if="testingMap[6]" @click="toTesting(testingMap[6])" class="female">
          <div class="flex-row-center">
            <img :src="testingMap[6].ossMaterial" />
          </div>
          <div class="title pl40">{{ testingMap[6].name }}</div>
          <div class="flex-row-between info pl40 pr40">
            <div>{{ testingMap[6].haveVip ? '会员免费' : testingMap[6].amount > 0 ? '￥' + testingMap[6].amount + '元' : '免费测试' }}</div>
            <div>{{ testingMap[6].count }}人购买</div>
          </div>
        </div>
        <div v-if="testingMap[7]" @click="toTesting(testingMap[7])" class="accurate">
          <div class="flex-row-center">
            <img :src="testingMap[7].ossMaterial" />
          </div>
          <div class="title pl40">{{ testingMap[7].name }}</div>
          <div class="flex-row-between info pl40 pr40">
            <div>{{ testingMap[7].haveVip ? '会员免费' : testingMap[7].amount > 0 ? '￥' + testingMap[7].amount + '元' : '免费测试' }}</div>
            <div>{{ testingMap[7].count }}人购买</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 问卷列表，需要判断权限 -->
    <!-- <div class="pl40 pr40 container">
      <div v-for="(item,index) in testingList" :key="index" :style="'background:url('+ item.ossMaterial +')'" class="testing flex-row-between">
        <div class="flex-col-center pr40">
          <div class="font-bigger">{{ item.name }}</div>
          <div class="font-intro mt10">{{ item.intro }}</div>
        </div>
        <div class="flex-col-center">
          <div @click="toTesting(item)" class="go">{{ item.amount > 0 ? item.amount + '元测试' : '免费测试' }}</div>
        </div>
      </div>
    </div> -->
    <!-- 进行中检测 -->
    <div class="ing-record">
      <div v-for="(item,index) in ingRecordList" :key="index" @click="itemClick(item)" class="block">
        <div class="circle">{{ item.testingName }}未完成</div>
      </div>
    </div>
    <!-- 检测方式 -->
    <van-action-sheet v-model="showAction" :actions="actions" @select="onSelect" />
    <!-- 使用券码 -->
    <!-- 输入框 -->
    <van-dialog v-model="showCard" title="使用券码" show-cancel-button :lazy-render="false" @confirm="submitCard">
      <van-field
        type="textarea"
        v-model="cardUid"
        rows="2"
        autosize
        autofocus
        maxlength="50"
        placeholder="请输入券码"
        show-word-limit
        class="message"
      />
    </van-dialog>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk';	// 使用js-sdk
import { Dialog, ActionSheet } from 'vant'
import axios from "axios"
import { fetchBanner } from '@/api/banner'
import { fetchTesting } from '@/api/testing'
import { jsSDKSign } from '@/api/login'
import { auth, h5Pay, recentRecord, fetchIngRecord, cardPay } from '@/api/testing-record'
import { isWeiXin } from '@/utils/tools'
import { ImagePreview, Toast } from 'vant';//引入预览
import { fetchUserInfo } from '../../api/user'
export default {
  data() {
    return {
      wxFlag: isWeiXin(),
      showAction: false,
      cardUid: '',
      showCard: false,
      actions: [
        { name: '付费评估', color: '#07c160' },
        { name: '使用兑换券', color: '#333333'},
        { name: '免费体验', color: '#A7A7A7' }
      ],
      wxShareConfig: {
        title: '邀您注册',
        desc: 'AI专属营养师',
        link: '',
        imgUrl: 'http://kangpingoss.oss-cn-beijing.aliyuncs.com/8d22029b9cd947d08237eb53f461a4cc.jpg',
        jsApiList: [ 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ' ], // 分享给朋友分享到QQ  分享到朋友圈 分享到腾讯微博
      },
      ingRecordList: [],
      recentList: [],
      payOrderId: '',
      testingList: [],
      testingMap: {},
      bannerList: [],
      images: []
    }
  },
  components: {
  },
  created() {
    localStorage.setItem('Route', '/index')
    // 清除
    localStorage.setItem('welcome-url', '')
    this.init()
  },
  watch: {
    $route() {
      this.init()
    }
  },
  methods: {
    toVipCard() {
      fetchUserInfo().then(() => {
        this.$router.push({
          path: '/vip-card',
          query: {}
        })
      })
    },
    async init() {
      if (localStorage.getItem('reload')) {
        localStorage.removeItem('reload')
        window.location.reload()
      }
      if (this.$route.query.companyId && this.$route.query.companyId != localStorage.getItem('CompanyId')) {
        localStorage.setItem('CompanyId', this.$route.query.companyId)
        window.location.reload()
      }
      this.wxShareConfig.link = `https://kpapi.kpjkgl.com/#/login?companyId=${localStorage.getItem('CompanyId')}&inviterId=${localStorage.getItem('UserId')}`
      // 加载banner图
      await fetchBanner().then(res => {
        this.bannerList = res
        res.forEach(it => {
          this.images.push(it.ossMaterial)
        })
      })
      // 加载问卷
      await fetchTesting().then(res => {
        this.testingList = res.content
        this.testingMap = {}
        this.testingList.forEach(it => {
          this.testingMap[it.id] = it
        })
      })
      // 进行中
      await fetchIngRecord().then(res => {
        this.ingRecordList = res
      })
      // 最近购买记录
      await recentRecord().then(res => {
        this.recentList = res
      })
      await jsSDKSign(window.location.href.split('#/')[0]).then(res => {
        this.injectAndShare(res)
      })
    },
    injectAndShare(signMsg) {

      const that = this
      signMsg.timestamp = signMsg.timestamp.toString()
      // 访问页面和获取页面必须保持一致
      // console.log('url 比对结果',  location.href.split('#')[0] === signMsg.url )
      wx.config({
        debug: false,  // 开发期间启用
        appId: signMsg.appId,
        timestamp: signMsg.timestamp,   // 注意！时间戳这里应该是10位字符串
        nonceStr: signMsg.nonceStr,     // 注意驼峰命名
        signature: signMsg.signature,
        jsApiList: [
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'onMenuShareWeibo',
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ'
        ],
      })

      wx.ready(() => {
        const { title, desc, link, imgUrl } = that.wxShareConfig
        console.log('wx.ready', '注入成功')

        // wx.checkJsApi({
        //   jsApiList:  ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ' ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        //   success: function(res) {
        //   // 可用的api值true，不可用为false
        //   // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        //     console.log('#####checkJsApi#####', res)
        //   }
        // });

        wx.updateAppMessageShareData({
          title, desc, link, imgUrl,
          success: function () {
            console.log('分享成功！')
          },
          cancel: function () {
            console.log('分享取消！')
          },
          fail: function () {
            console.log('分享失败！')
          }
        })

        wx.updateTimelineShareData({
          title, desc, link, imgUrl,
          success: function () {
            console.log('分享成功！')
          },
          cancel: function () {
            console.log('分享取消！')
          },
          fail: function () {
            console.log('分享失败！')
          }
        })


        wx.onMenuShareWeibo({
          title, desc, link, imgUrl,
          success: function () {
            console.log('分享成功！')
          },
          cancel: function () {
            console.log('分享取消！')
          },
          fail: function () {
            console.log('分享失败！')
          }
        })

        // 即将废弃（为兼容安卓最好加上）
        wx.onMenuShareTimeline({
          title, desc, link, imgUrl,
          success: function () {
            console.log('分享成功！')
          },
          cancel: function () {
            console.log('分享取消！')
          },
          fail: function () {
            console.log('分享失败！')
          }
        })

        // 即将废弃（为兼容安卓最好加上）
        wx.onMenuShareAppMessage({
          title, desc, link, imgUrl,
          success: function () {
            console.log('分享成功！')
          },
          cancel: function () {
            console.log('分享取消！')
          },
          fail: function () {
            console.log('分享失败！')
          }
        })

        // 即将废弃（为兼容安卓最好加上）
        wx.onMenuShareQQ({
          title, desc, link, imgUrl,
          success: function () {
            console.log('分享成功！')
          },
          cancel: function () {
            console.log('分享取消！')
          },
          fail: function () {
            console.log('分享失败！')
          }
        })

      })

      wx.error(function (res) {
        console.log('wx error:', res)
      })

    },
    injectAndShare(signMsg) {
      const that = this
      signMsg.timestamp = signMsg.timestamp.toString()
      // 访问页面和获取页面必须保持一致
      // console.log('url 比对结果',  location.href.split('#')[0] === signMsg.url )
      wx.config({
        debug: false,  // 开发期间启用
        appId: signMsg.appId,
        timestamp: signMsg.timestamp,   // 注意！时间戳这里应该是10位字符串
        nonceStr: signMsg.nonceStr,     // 注意驼峰命名
        signature: signMsg.signature,
        jsApiList: [
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'onMenuShareWeibo',
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ'
        ],
      })

      wx.ready(() => {
        const { title, desc, link, imgUrl } = that.wxShareConfig
        console.log('wx.ready', '注入成功')

        // wx.checkJsApi({
        //   jsApiList:  ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ' ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        //   success: function(res) {
        //   // 可用的api值true，不可用为false
        //   // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        //     console.log('#####checkJsApi#####', res)
        //   }
        // });

        wx.updateAppMessageShareData({
          title, desc, link, imgUrl,
          success: function () {
            console.log('分享成功！')
          },
          cancel: function () {
            console.log('分享取消！')
          },
          fail: function () {
            console.log('分享失败！')
          }
        })

        wx.updateTimelineShareData({
          title, desc, link, imgUrl,
          success: function () {
            console.log('分享成功！')
          },
          cancel: function () {
            console.log('分享取消！')
          },
          fail: function () {
            console.log('分享失败！')
          }
        })


        wx.onMenuShareWeibo({
          title, desc, link, imgUrl,
          success: function () {
            console.log('分享成功！')
          },
          cancel: function () {
            console.log('分享取消！')
          },
          fail: function () {
            console.log('分享失败！')
          }
        })

        // 即将废弃（为兼容安卓最好加上）
        wx.onMenuShareTimeline({
          title, desc, link, imgUrl,
          success: function () {
            console.log('分享成功！')
          },
          cancel: function () {
            console.log('分享取消！')
          },
          fail: function () {
            console.log('分享失败！')
          }
        })

        // 即将废弃（为兼容安卓最好加上）
        wx.onMenuShareAppMessage({
          title, desc, link, imgUrl,
          success: function () {
            console.log('分享成功！')
          },
          cancel: function () {
            console.log('分享取消！')
          },
          fail: function () {
            console.log('分享失败！')
          }
        })

        // 即将废弃（为兼容安卓最好加上）
        wx.onMenuShareQQ({
          title, desc, link, imgUrl,
          success: function () {
            console.log('分享成功！')
          },
          cancel: function () {
            console.log('分享取消！')
          },
          fail: function () {
            console.log('分享失败！')
          }
        })

      })

      wx.error(function (res) {
        console.log('wx error:', res)
      })
    },
    toTestingRecord() {
      fetchUserInfo().then(() => {
        this.$router.push({
          path: '/testing-record',
          query: {}
        })
      })
    },
    // 轮播图预览
    previewImg(images, index) {
        ImagePreview({
            images: images,//图片数组
            showIndex: true,
            loop: false,
            startPosition: index
        })
    },
    itemClick(item) {
      fetchUserInfo().then(res => {
        if (item.testingId == 7) {
          window.location.href = 'https://kpapi.kpjkgl.com/H5/#/login?userId='+ localStorage.getItem('Tel') +'&inspectOrder='+ item.times +'&role=1&allow=true&companyId='+ item.companyId +'&isEdit=1'
          // var sign = this.$md5(res.tel + 'kangping').substring(8, 24)
          // axios({
          //     method: 'post',
          //     url: 'https://ai.kpjkgl.com:444/userLogin/loginAllow?userId='+ res.tel +'&md5Tag='+ sign +'&channelName=kangping'
          // })
          // .then(response => {
          //   if (response.data.code == 200) {
          //     var data = response.data.data
          //     location.href = 'https://kpapi.kpjkgl.com/H5/#/login?userId=' + data.userId + '&role=' + data.role + '&allow=' + data.allow
          //   } else{
          //     // 提示语
          //     Toast(response.data.msg)
          //   }
          // })
          return false
        } else {
          this.$router.push({
            path: '/testing-info',
            query: {
              testingId: item.testingId,
              testingRecordId: item.id
            }
          })
        }
      })
    },
    toOld() {
      // 去老版
      // location.href = 'https://kpapi.kpjkgl.com/H5/#/homePage'
      var sign = this.$md5(localStorage.getItem('tel') + 'kangping').substring(8, 24)
      console.info(sign)
      axios({
          method: 'post',
          url: 'https://ai.kpjkgl.com:444/userLogin/loginAllow?userId='+ localStorage.getItem('tel') +'&md5Tag='+ sign +'&channelName=kangping'
      })
      .then(response => {
        console.info(response)
        if (response.data.code == 200) {
          var data = response.data.data
          location.href = 'https://kpapi.kpjkgl.com/H5/#/login?userId=' + data.userId + '&role=' + data.role + '&allow=' + data.allow
        } else{
          // 提示语
          Toast(response.data.msg)
        }
      })
    },
    onSelect(item) {
      var testingId = localStorage.getItem('testingId')
      // 默认情况下，点击选项时不会自动关闭菜单
      // 可以通过 close-on-click-action 属性开启自动关闭
      this.showAction = false
      if (item.name === '付费评估') {
        // 确认了，支付
        if (isWeiXin()) {
          // 公众号支付
          auth({
            testingId: testingId
          }).then(res => {
            window.location.href = res
          })
        } else {
          // h5支付
          h5Pay({
            testingId: testingId
          }).then(res => {
            this.payOrderId = res.id
            localStorage.setItem('payOrderId', res.id)
            localStorage.setItem('testingId', this.checked)
            // 保存
            if (res.state.key == 'Succeed') {
              // 成功了
              if (localStorage.getItem('testingId') == '7') {
                // 去老版
                this.toOld()
                return false
              } else {
                this.$router.push({
                  path: '/testing-info',
                  query: {
                    testingId: this.testingId,
                    testingRecordId: res.relationId
                  }
                })
              }
            } else {
              // 跳转支付
              location.href = res.payJson + '&redirect_url=' + encodeURIComponent(location.href.replace('index', 'testing-info?testingId='+ this.testingId +'&testingRecordId=' + res.relationId) + '&t=' + new Date().getMilliseconds())
            }
          })
        }
      }
      if (item.name === '免费体验') {
        // 免费的
        this.$router.push({
          path: '/testing-info',
          query: {
            testingId: testingId,
            experientialFlag: true
          }
        })
      }
      if (item.name === '使用兑换券') {
        // 券码
        this.cardUid = ''
        this.showCard = true
      }
    },
    submitCard() {
      // 使用优惠券兑换
      var testingId = localStorage.getItem('testingId')
      cardPay({
        testingId: testingId,
        cardUid: this.cardUid
      }).then(res => {
        // 跳转
        this.$router.push({
          path: '/testing-info',
          query: {
            testingId: testingId,
            testingRecordId: res
          }
        })
      })
    },
    toTesting(item) {
      if (item.id == 7) {
        // 简版测试，跳转
        // 获取授权信息
        fetchUserInfo().then(res => {
          var sign = this.$md5(res.tel + 'kangping').substring(8, 24)
          console.info(sign)
          axios({
              method: 'post',
              url: 'https://ai.kpjkgl.com:444/userLogin/loginAllow?userId='+ res.tel +'&md5Tag='+ sign +'&channelName=kangping'
          })
          .then(response => {
            console.info(response)
            if (response.data.code == 200) {
              var data = response.data.data
              location.href = 'https://kpapi.kpjkgl.com/H5/#/login?userId=' + data.userId + '&role=' + data.role + '&allow=' + data.allow
            } else{
              // 提示语
              Toast(response.data.msg)
            }
          })
        })
        return false
      } else {
        if (item.amount > 0 && !item.haveVip) {
          // 获取授权链接
          localStorage.setItem('testingId', item.id)
          this.showAction = true
          // Dialog.confirm({
          //   title: '提示',
          //   message: '您可选择付费完整评估，或免费体验',
          //   confirmButtonText: '付费评估',
          //   cancelButtonText: '免费体验'
          // }).then(() => {
          //   // 确认了，支付
          //   if (isWeiXin()) {
          //     // 公众号支付
          //     auth({
          //       testingId: item.id
          //     }).then(res => {
          //       window.location.href = res
          //     })
          //   } else {
          //     // h5支付
          //     h5Pay({
          //       testingId: item.id
          //     }).then(res => {
          //       this.payOrderId = res.id
          //       localStorage.setItem('payOrderId', res.id)
          //       localStorage.setItem('testingId', this.checked)
          //       // 保存
          //       if (res.state.key == 'Succeed') {
          //         // 成功了
          //         if (localStorage.getItem('testingId') == '7') {
          //           // 去老版
          //           this.toOld()
          //           return false
          //         } else {
          //           this.$router.push({
          //             path: '/testing-info',
          //             query: {
          //               testingId: this.testingId,
          //               testingRecordId: res.relationId
          //             }
          //           })
          //         }
          //       } else {
          //         // 跳转支付
          //         location.href = res.payJson + '&redirect_url=' + encodeURIComponent(location.href.replace('index', 'testing-info?testingId='+ this.testingId +'&testingRecordId=' + res.relationId) + '&t=' + new Date().getMilliseconds())
          //       }
          //     })
          //   }
          //   }).catch(() => {
          //     // 免费的
          //     this.$router.push({
          //       path: '/testing-info',
          //       query: {
          //         testingId: item.id,
          //         experientialFlag: true
          //       }
          //     })
          //   })
        } else {
          this.$router.push({
            path: '/testing-info',
            query: {
              testingId: item.id
            }
          })
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.recent {
  background: url(../../assets/images/index-bg.png) no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: calc(100vw * 0.54669887279);
  .empty {
    padding: calc(100vw * 0.54669887279 - 80px) 40px 0 40px;
  }
  .van-notice-bar {
    border-radius: 48px;
    height: 60px;
  }
  .notice-swipe {
    margin: 0;
    height: 40px;
    line-height: 40px;
  }
  .van-swipe-item {
    font-size: 0.32rem;
  }
}
.swiper {
  width: 100%;
  img {
    width: 100%;
  }
}

.buy-vip {
  margin-top: 24px;
  padding: 0 24px;
  img {
    width: 100%;
  }
}
.container {
  margin-top: 24px;
  padding: 0 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 320px;
  .female {
    width: calc(50vw - 36px);
    background: #fff;
    box-sizing: border-box;
    border-radius: 24px;
    border: 6px solid rgb(254,234,236);
    img {
      margin: 0;
      width: calc(50vw - 52px);
      height: calc(50vw - 52px);
      border-radius: 24px 24px 0 0;
    }
    .title {
      margin-top: 24px;
      height: 0.42rem;
      line-height: 0.42rem;
      font-size: 0.42rem;
      font-weight: bold;
      color: rgb(229,95,67);
    }
    .info {
      margin-top: 24px;
      margin-bottom: 24px;
      height: 0.32rem;
      line-height: 0.32rem;
      div:first-child {
        font-weight: bold;
        font-size: 0.32rem;
        color: rgb(229,95,67);
      }
      div:last-child {
        color: rgb(156,156,156);
        font-size: 0.32rem;
      }
    }
  }
  .accurate {
    width: calc(50vw - 36px);
    margin-top: 24px;
    background: #fff;
    box-sizing: border-box;
    border-radius: 24px;
    border: 6px solid rgb(254,236,204);
    img {
      border-radius: 24px 24px 0 0;
      width: calc(50vw - 52px);
      height: calc(50vw - 52px);
    }
    .title {
      height: 0.42rem;
      line-height: 0.42rem;
      margin-top: 24px;
      font-size: 0.42rem;
      font-weight: bold;
      color: rgb(253,162,29);
    }
    .info {
      height: 0.32rem;
      line-height: 0.32rem;
      margin-top: 24px;
      margin-bottom: 24px;
      div:first-child {
        font-weight: bold;
        font-size: 0.32rem;
        color: rgb(253,162,29);
      }
      div:last-child {
        color: rgb(156,156,156);
        font-size: 0.32rem;
      }
    }
  }
  .child {
    width: calc(50vw - 36px);
    background: #fff;
    box-sizing: border-box;
    border-radius: 24px;
    border: 6px solid rgb(226,229,244);
    img {
      border-radius: 24px 24px 0 0;
      width: calc(50vw - 48px);
      height: calc((50vw - 48px) * 1.5837);
    }
    .title {
      height: 0.42rem;
      line-height: 0.42rem;
      margin-top: 24px;
      font-size: 0.42rem;
      font-weight: bold;
      color: rgb(42,66,147);
    }
    .info {
      height: 0.32rem;
      line-height: 0.32rem;
      margin-top: 24px;
      margin-bottom: 24px;
      div:first-child {
        font-weight: bold;
        font-size: 0.32rem;
        color: rgb(42,66,147);
      }
      div:last-child {
        color: rgb(156,156,156);
        font-size: 0.32rem;
      }
    }
  }
  .my-report {
    margin-top: 24px;
    width: calc(50vw - 36px);
    height: calc(50vw - 166px + 0.32rem + 0.42rem);
    background: #fff;
    box-sizing: border-box;
    border-radius: 24px;
    border: 8px solid rgb(233,233,233);
    img {
      width: 96px;
      height: 118px;
    }
    .title {
      margin-top: 24px;
      font-size: 0.42rem;
      font-weight: bold;
    }
  }
}
.testing {
  padding: 24px 40px;
  margin-top: 24px;
  border-radius: 24px;
  background: #fff;
  .go {
    background: #ff9e19;
    color: #fff;
    font-size: 0.32rem;
    height: 48px;
    width: 120px;
    text-align: center;
    line-height: 50px;
    border-radius: 16px;
  }
}
.ing-record {
  position: fixed;
  bottom: 144px;
  left: 0;
  padding: 0 40px;
  // .item {
  //   font-size: 0.32rem;
  //   color: #fff;
  //   margin-top: 24px;
  //   padding: 8px 24px;
  //   border-radius: 24px;
  //   background: rgba(0, 0, 0, 0.7);
  // }
  .block {
    font-size: 0.24rem;
    color: #fff;
    margin-top: 24px;
    padding: 8px 24px;
    border-radius: 24px;
  }

  @keyframes twinkling {
      0% {
          opacity: 0.2;
          filter: alpha(opacity=20);
          transform: scale(1);
      }

      50% {
          opacity: 0.5;
          filter: alpha(opacity=50);
          transform: scale(1.12);
      }

      100% {
          opacity: 0.2;
          filter: alpha(opacity=20);
          transform: scale(1);
      }
  }


  .circle {
    display: flex;
    align-items: center;
    text-align: center;
    width: 104px;
    height: 120px;
    border-radius: 50%;
    background: #3a96e1;
    text-align: center;
    position: relative;
    padding: 0 8px;
    z-index: 1;
  }

  .circle::before {
      background: inherit;
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: -2;
      border-radius: 50%;
      animation: twinkling 2.2s ease-in-out infinite;
  }

  .circle::after {
      background: inherit;
      content: '';
      position: absolute;
      width: 110%;
      height: 110%;
      left: -5%;
      top: -5%;
      z-index: -1;
      border-radius: 50%;
      animation: twinkling 2.2s ease-in-out infinite;
  }
}
</style>